import { query } from "./strapi";

// Define interfaces for product attributes and values
interface ProductAttributeValue {
  name: string;
  colorHex?: string | null;
}

interface ProductAttribute {
  name: string;
  uniqueName: string;
  values?: ProductAttributeValue[];
  product_attribute_values?: ProductAttributeValue[];
}

export function getProduct(productUrl: string) {
  console.log(`Getting product for URL: ${productUrl}`);

  return query(`product/${productUrl}`)
    .then((res) => {
      if (!res?.data) {
        console.warn(`No data returned for product: ${productUrl}`);
        return {};
      }

      // Format response for SEO requirements
      const product = res.data;

      console.log(
        `Product data retrieved: ID=${product.id}, Name=${
          product.name
        }, HasSEO=${!!product.seo}`
      );

      // Ensure SEO data is properly formatted
      if (product.seo) {
        // Make sure we have valid canonical URL
        if (!product.seo.canonicalURL && product.url) {
          product.seo.canonicalURL = `https://evefant.com/p/${product.url}`;
        }

        // Generate keywords from product data if not provided
        if (!product.seo.keywords) {
          const keywordSources = [
            product.name,
            ...(product.attributes
              ?.map((attr: ProductAttribute) =>
                attr.values?.map((val: ProductAttributeValue) => val.name)
              )
              .flat() || []),
          ];
          product.seo.keywords = keywordSources.filter(Boolean).join(", ");
        }

        // Ensure we have meta description
        if (!product.seo.metaDescription && product.description) {
          product.seo.metaDescription = product.description.substring(0, 160);
        }
      } else {
        console.log("Product missing SEO data, creating defaults");
        // Create default SEO object if missing
        product.seo = {
          metaTitle: product.name,
          metaDescription:
            product.description?.substring(0, 160) ||
            `Compra ${product.name} en Evefant`,
          keywords: product.name,
          canonicalURL: product.url
            ? `https://evefant.com/p/${product.url}`
            : null,
        };
      }

      // Ensure extraFields is always present
      if (!product.extraFields) {
        product.extraFields = null;
      }

      return product;
    })
    .catch((err) => {
      console.error("Error fetching product:", err);
      throw err; // Rethrow to handle in component
    });
}
